<div class="modal-overlay" (click)="onBackdropClick()" *ngIf="!addNewFieldOpened">
  <div class="modal-section" (click)="$event.stopPropagation()">
    <div class="header">
      <h3>New Equipment</h3>
    </div>
    <hr>
    <div class="body">
      <div class="add-new-field-section">
        <button type="button" class="btn add-field-btn" (click)="onAddField()">
          Add New Field
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.75 7.75781C12.75 7.3436 12.4142 7.00781 12 7.00781C11.5858 7.00781 11.25 7.3436 11.25 7.75781V11.2505H7.75736C7.34315 11.2505 7.00736 11.5862 7.00736 12.0005C7.00736 12.4147 7.34315 12.7505 7.75736 12.7505H11.25V16.2431C11.25 16.6573 11.5858 16.9931 12 16.9931C12.4142 16.9931 12.75 16.6573 12.75 16.2431V12.7505H16.2426C16.6569 12.7505 16.9926 12.4147 16.9926 12.0005C16.9926 11.5862 16.6569 11.2505 16.2426 11.2505H12.75V7.75781Z" fill="var(--primary-color)"/>
          </svg>
        </button>
      </div>
      
      <hr>
      <div class="form-group section-part device-name">
        <label>Equipment Name</label>
        <input type="text" placeholder="Enter Equipment Name" [(ngModel)]="sectionDefinition.name" />
      </div>

      <div class="device-types" *ngFor="let attributeDefinition of sectionDefinition.attributeDefinitions; let i = index">
        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.Dropdown" class="form-section section-part mb-4">
          <div 
            class="section-header d-flex justify-content-between align-items-center"
            data-bs-toggle="collapse"
            [attr.href]="'#deviceTypeCollapse' + i"
            role="button"
            aria-expanded="false"
            [attr.aria-controls]="'deviceTypeCollapse' + i"
          >
            <span class="section-title">{{ sectionDefinition.attributeDefinitions[i].label }}</span>
          
            <svg class="chevron-icon" width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.83366 2.69392L6.14679 0.380825C6.34206 0.185558 6.65859 0.185558 6.85386 0.380825C7.04912 0.576085 7.04912 0.892658 6.85386 1.08792L4.42292 3.51892C4.09746 3.84432 3.56986 3.84432 3.24439 3.51892L0.813437 1.08792C0.618177 0.892658 0.618177 0.576085 0.813437 0.380825C1.0087 0.185558 1.32528 0.185558 1.52054 0.380825L3.83366 2.69392Z" fill="#17171A" fill-opacity="0.8"/>
            </svg>

          </div>

          <!-- Collapsible Body -->
          <div [attr.id]="'deviceTypeCollapse' + i" class="collapse">
            <div class="option-section mt-3">

              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-medium dropdown-label">Dropdown Options</span>
                <button type="button add-field-btn" class="btn add-field-btn p-0 d-flex align-items-center" (click)="addOption(attributeDefinition)">
                  <span class="me-1 fw-medium">Add Option</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.75 7.75781C12.75 7.3436 12.4142 7.00781 12 7.00781C11.5858 7.00781 11.25 7.3436 11.25 7.75781V11.2505H7.75736C7.34315 11.2505 7.00736 11.5862 7.00736 12.0005C7.00736 12.4147 7.34315 12.7505 7.75736 12.7505H11.25V16.2431C11.25 16.6573 11.5858 16.9931 12 16.9931C12.4142 16.9931 12.75 16.6573 12.75 16.2431V12.7505H16.2426C16.6569 12.7505 16.9926 12.4147 16.9926 12.0005C16.9926 11.5862 16.6569 11.2505 16.2426 11.2505H12.75V7.75781Z" fill="var(--primary-color)"/>
                  </svg>
                </button>
              </div>

              <div
                cdkDropList
                (cdkDropListDropped)="drop($event, attributeDefinition.optionDefinitions)"
                class="options-list"
              >
                <div
                  *ngFor="let option of attributeDefinition.optionDefinitions; let i = index"
                  cdkDrag
                  class="option-item mb-2"
                >
                  <div class="input-wrapper d-flex align-items-center position-relative">
                    <div class="draggable-div" cdkDragHandle>
                      <svg width="25" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.99347 15.2311C1.655 15.2311 1.36526 15.1106 1.12424 14.8695C0.883211 14.6285 0.762695 14.3388 0.762695 14.0003C0.762695 13.6618 0.883211 13.3721 1.12424 13.1311C1.36526 12.8901 1.655 12.7695 1.99347 12.7695C2.33194 12.7695 2.62168 12.8901 2.86269 13.1311C3.10373 13.3721 3.22424 13.6618 3.22424 14.0003C3.22424 14.3388 3.10373 14.6285 2.86269 14.8695C2.62168 15.1106 2.33194 15.2311 1.99347 15.2311ZM7.99347 15.2311C7.655 15.2311 7.36526 15.1106 7.12424 14.8695C6.88321 14.6285 6.76269 14.3388 6.76269 14.0003C6.76269 13.6618 6.88321 13.3721 7.12424 13.1311C7.36526 12.8901 7.655 12.7695 7.99347 12.7695C8.33193 12.7695 8.62168 12.8901 8.86269 13.1311C9.10373 13.3721 9.22424 13.6618 9.22424 14.0003C9.22424 14.3388 9.10373 14.6285 8.86269 14.8695C8.62168 15.1106 8.33193 15.2311 7.99347 15.2311ZM1.99347 9.23108C1.655 9.23108 1.36526 9.11057 1.12424 8.86953C0.883211 8.62852 0.762695 8.33878 0.762695 8.00031C0.762695 7.66184 0.883211 7.3721 1.12424 7.13108C1.36526 6.89005 1.655 6.76953 1.99347 6.76953C2.33194 6.76953 2.62168 6.89005 2.86269 7.13108C3.10373 7.3721 3.22424 7.66184 3.22424 8.00031C3.22424 8.33878 3.10373 8.62852 2.86269 8.86953C2.62168 9.11057 2.33194 9.23108 1.99347 9.23108ZM7.99347 9.23108C7.655 9.23108 7.36526 9.11057 7.12424 8.86953C6.88321 8.62852 6.76269 8.33878 6.76269 8.00031C6.76269 7.66184 6.88321 7.3721 7.12424 7.13108C7.36526 6.89005 7.655 6.76953 7.99347 6.76953C8.33193 6.76953 8.62168 6.89005 8.86269 7.13108C9.10373 7.3721 9.22424 7.66184 9.22424 8.00031C9.22424 8.33878 9.10373 8.62852 8.86269 8.86953C8.62168 9.11057 8.33193 9.23108 7.99347 9.23108ZM1.99347 3.23108C1.655 3.23108 1.36526 3.11057 1.12424 2.86953C0.883211 2.62852 0.762695 2.33877 0.762695 2.00031C0.762695 1.66184 0.883211 1.3721 1.12424 1.13108C1.36526 0.890049 1.655 0.769531 1.99347 0.769531C2.33194 0.769531 2.62168 0.890049 2.86269 1.13108C3.10373 1.3721 3.22424 1.66184 3.22424 2.00031C3.22424 2.33877 3.10373 2.62852 2.86269 2.86953C2.62168 3.11057 2.33194 3.23108 1.99347 3.23108ZM7.99347 3.23108C7.655 3.23108 7.36526 3.11057 7.12424 2.86953C6.88321 2.62852 6.76269 2.33877 6.76269 2.00031C6.76269 1.66184 6.88321 1.3721 7.12424 1.13108C7.36526 0.890049 7.655 0.769531 7.99347 0.769531C8.33193 0.769531 8.62168 0.890049 8.86269 1.13108C9.10373 1.3721 9.22424 1.66184 9.22424 2.00031C9.22424 2.33877 9.10373 2.62852 8.86269 2.86953C8.62168 3.11057 8.33193 3.23108 7.99347 3.23108Z" fill="#151918" fill-opacity="0.8"/>
                      </svg>
                    </div>
                    

                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="option.value"
                      placeholder="Option {{ i + 1 }}"
                    />

                    <div class="dots-wrapper position-relative">
                      <span class="icon dots" (click)="toggleDropdown(i)">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1.5C8.27513 1.5 7.6875 2.08763 7.6875 2.8125C7.6875 3.53738 8.27513 4.125 9 4.125C9.72488 4.125 10.3125 3.53738 10.3125 2.8125C10.3125 2.08763 9.72488 1.5 9 1.5Z" fill="black"/>
                          <path d="M9 7.6875C8.27513 7.6875 7.6875 8.27513 7.6875 9C7.6875 9.72488 8.27513 10.3125 9 10.3125C9.72488 10.3125 10.3125 9.72488 10.3125 9C10.3125 8.27513 9.72488 7.6875 9 7.6875Z" fill="black"/>
                          <path d="M9 13.875C8.27513 13.875 7.6875 14.4626 7.6875 15.1875C7.6875 15.9124 8.27513 16.5 9 16.5C9.72488 16.5 10.3125 15.9124 10.3125 15.1875C10.3125 14.4626 9.72488 13.875 9 13.875Z" fill="black"/>
                        </svg>
                      </span>

                      <div class="dropdown-delete" *ngIf="activeDropdownIndex === i">
                        <button class="btn btn-danger" (click)="deleteOption(attributeDefinition, i)">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.Text" class="text-field">
          <input type="text" [(ngModel)]="sectionDefinition.attributeDefinitions[i].label" disabled/>
        </div>

        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.Bool" class="multiple-device section-part toggle-group">
          <label>{{ sectionDefinition.attributeDefinitions[i].label }}</label>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="sectionDefinition.attributeDefinitions[i].defaultState" disabled />
            <span class="slider"></span>
          </label>
        </div>

        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.Number" class="text-field">
          <input type="text" [(ngModel)]="sectionDefinition.attributeDefinitions[i].label" disabled/>
        </div>

        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.ConditionalDropdown" class="text-field">
          <input type="text" [(ngModel)]="sectionDefinition.attributeDefinitions[i].label" disabled/>
        </div>

        <div *ngIf="sectionDefinition.attributeDefinitions[i].fieldType == FormTypes.DateTime" class="text-field">
          <input type="text" [(ngModel)]="sectionDefinition.attributeDefinitions[i].label" disabled/>
        </div>
      </div>

      <div class="asset-type section-header section-part mb-4">
        <div class="asset-type-expandable" 
            data-bs-toggle="collapse" 
            data-bs-target="#assetTypeCollapse"
            role="button" 
            aria-expanded="false" 
            aria-controls="assetTypeCollapse"
            >
          <span class="section-title">Asset Type</span>
          <svg class="chevron-icon" width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.83366 2.69392L6.14679 0.380825C6.34206 0.185558 6.65859 0.185558 6.85386 0.380825C7.04912 0.576085 7.04912 0.892658 6.85386 1.08792L4.42292 3.51892C4.09746 3.84432 3.56986 3.84432 3.24439 3.51892L0.813437 1.08792C0.618177 0.892658 0.618177 0.576085 0.813437 0.380825C1.0087 0.185558 1.32528 0.185558 1.52054 0.380825L3.83366 2.69392Z" fill="#17171A" fill-opacity="0.8"/>
          </svg>
        </div>
        <div id="assetTypeCollapse" class="asset-type-list collapse">
          <div class="card-body d-flex flex-wrap gap-2">
            <label
              click-stop-propagation
              *ngFor="let type of entityTypes; let i = index"
              class="custom-checkbox-box"
              [class.active]="selectedEntityType === type"
              [attr.for]="'asset-' + i"
              (click)="toggleAsset(type)"
            >
              <input
                type="checkbox"
                [checked]="selectedEntityType === type"
              />
              <span>{{ entityTypeLabels[type] || "Unknown" }}</span>
            </label>

          </div>
        </div>
      </div>

      <div class="multiple-device section-part toggle-group">
        <label>Multiple Equipment</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="sectionDefinition.multipleDevice" />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <hr>

    <div class="footer">
      <button class="cancel" (click)="onCancel()">Cancel</button>
      <button class="save" (click)="onSave()">Save</button>
    </div>
  </div>

</div>

<app-add-new-network-device-field *ngIf="addNewFieldOpened" 
                                  (closeModalEvent)="onCloseAddNewFieldModal()"
                                  [attributes]="sectionDefinition.attributeDefinitions"
                                  >
</app-add-new-network-device-field>